/**
 * 金额显示：最小货币单位整数派生为元展示，禁止浮点运算失真。
 * 覆盖 admin-web-shell:SC-17。
 */

export interface MoneyDisplayProps {
  /** 最小货币单位整数（分） */
  amountInCents: number;
  /** 币种（默认 CNY） */
  currency?: string;
}

export function MoneyDisplay({ amountInCents, currency = 'CNY' }: MoneyDisplayProps) {
  // 整数分转字符串元：避免浮点，分两组（整数元/分），padStart 保证两位分
  const sign = amountInCents < 0 ? '-' : '';
  const abs = Math.abs(amountInCents);
  const yuan = Math.floor(abs / 100);
  const cents = abs % 100;
  const formatted = `${sign}${yuan}.${cents.toString().padStart(2, '0')}`;
  return (
    <span>
      {currency === 'CNY' ? '¥' : currency} {formatted}
    </span>
  );
}
